"use client";

// must render as a client component, otherwise there if there are no other client components that use fontawesome rendered on the page, the fontawesome styles will not be applied and you get a giant chevron
import Link, { type LinkProps } from "next/link";

import { USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME } from "@shared/constants";

import {
  ButtonContent,
  type CommonButtonProps,
  createButtonClassNames,
  determineIcon,
} from "./common-button-resources";

// We use type intersection here due to non-compatible overlap of onClick types
type LinkButtonProps = {
  href: string;
  text: string;
  target?: "_self" | "_blank" | "_parent" | "_top" | "unfencedTop";
  iconLeftBandaid?: boolean;
} & CommonButtonProps &
  LinkProps;

export function LinkButton({
  chevron,
  className,
  color,
  componentStyle,
  href,
  iconRight,
  size,
  variant,
  text,
  iconLeftBandaid,
  ...rest
}: LinkButtonProps) {
  const classNames = createButtonClassNames({
    className,
    color,
    componentStyle,
    iconRight,
    size,
    variant,
  });

  if (!href) {
    throw new Error("Link must have a href");
  }

  const icon = determineIcon({ chevron, iconRight });

  return (
    <Link
      className={classNames}
      href={href}
      {...USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME}
      {...rest}
    >
      {iconLeftBandaid && iconRight}
      <ButtonContent
        icon={icon}
        text={text}
        iconLeftBandaid={iconLeftBandaid}
      />
    </Link>
  );
}
